export default __webpack_public_path__ + "static/media/about.cd7bbccd.jpg";